export class Enrol {
  cohort: any;
  course: any;
  courseLevel: number;
  nativeLocale: string;
  stripePayment: {
    paymentId: string;
    paymentSecret: string;
    status: string;
  };
  wantedLocale: string;

  constructor() {
    this.cohort = null;
    this.course = null;
    this.courseLevel = 0;
    this.nativeLocale = '';
    this.stripePayment = {
      paymentId: '',
      paymentSecret: '',
      status: '',
    };
    this.wantedLocale = '';
  }
}
